<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
	name: 'App'
}
</script>

<style lang="scss">
@import url("./assets/css/reset.css");
@import url("https://fonts.googleapis.com/css?family=Roboto+Condensed:300,400,700|Roboto:400,400i,700,700i&display=swap");
@import url("https://fonts.googleapis.com/icon?family=Material+Icons");
@import url("../node_modules/@fortawesome/fontawesome-free/css/all.min.css");

html {
	scroll-behavior: smooth;
}

body {
	min-height: 100vh;
	background-color: #1B2838;
	background-image: linear-gradient(to bottom, #011536, #1B2838);

	&.light {
		background-color: #EFEFEF;
		background-image: unset;
	}
}

#app {
  font: 400 1em/1.625em Roboto, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
	scroll-behavior: smooth;

	* {
		box-sizing: border-box;
	}
}

.container {
	max-width: 1366px;
	margin: 0 auto;
	flex-wrap: wrap;
}
.multiselect {
	background: #fff;
	border: 0;
	border-radius: 4px;
}

.multiselect__tags {
		padding: 8px 40px 0 0 !important;
		border-radius: 0;
		border: none !important;
		background: transparent !important;
		font-size: 1em;
	}
	.multiselect__placeholder {
		color: #1a2738 !important;
		font-size: 1em;
		font-weight: 700;
		margin-bottom: 0px !important;
		padding-left: 10px;
	}

	.multiselect__input, .multiselect__single {
		vertical-align: middle !important;
		background: transparent !important;
		position: relative;
		top: 4px;
	}
	.title {
		.multiselect__single {
			color: #fff !important;
		}
	}
	.multiselect__content-wrapper {
		background: #f3f7fc !important;
	}

	.multiselect--disabled  {
		background: transparent !important;
	}

	.multiselect--disabled .multiselect__current, .multiselect--disabled .multiselect__select {
    background: transparent !important;
	}

	.input-format {
		height: 40px;
		padding-left: 25px;
		width: 140px;
		border: 0;
		border-radius: 4px;
		background-color: #000;
		color: #fff;
		*:focus {
			outline: none;
		}
	}
	.input-format:focus {
			outline: none;
	}
	// .vdp-datepicker__calendar {
	// 	color: #000;
	// }
	.filters {
		.box-data {
			.data {
				.vdp-datepicker__calendar {
					left: -166px;
				}
			}
		}
	}

	.vdp-datepicker__clear-button {
		position: absolute !important;
		left: 185px !important;
		font-size: 19px !important;
		top: 7px !important;
		i {
			font-size: 30px;
		}
	}

</style>
